import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { PatentLinkImpl } from './impls/patent-link';
import { PatentLink } from './link-service';

/**
 * 链接管理模块
 * @param bind
 */
export function linkModule(bind: interfaces.Bind) {
    bind(PatentLink).to(PatentLinkImpl);
}
